import { Component, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Log to monitoring service in production
    if (import.meta.env.PROD) {
      // TODO: Send to error tracking service (Sentry, etc)
      console.error('Production error caught:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="min-h-screen bg-black flex items-center justify-center text-white px-6">
          <div className="text-center max-w-md">
            <div className="mb-8">
              <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-red-500/20 flex items-center justify-center">
                <i className="ri-error-warning-line text-4xl text-red-500"></i>
              </div>
              <h1 className="text-3xl md:text-4xl font-light mb-4 text-gray-200">
                Something went wrong
              </h1>
              <p className="text-gray-400 mb-8">
                We encountered an unexpected error. Please try refreshing the page.
              </p>
            </div>
            <button 
              onClick={() => window.location.href = '/'}
              className="px-8 py-3 bg-teal-500 hover:bg-teal-600 rounded-lg font-medium transition-colors"
            >
              Return Home
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
